import { render, staticRenderFns } from "./ExtrasTable.vue?vue&type=template&id=e62b4afe"
import script from "./ExtrasTable.vue?vue&type=script&lang=js"
export * from "./ExtrasTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports